import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ac91e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "models" }
const _hoisted_3 = { class: "model-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Alle Sprachmodelle", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Training für alle starten")
const _hoisted_6 = { class: "model-content" }
const _hoisted_7 = { class: "button-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Training starten")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_md_button, {
          variant: "filled",
          disabled: !_ctx.trainingRequired,
          onClick: _ctx.startTrainingForEveryModel
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.models, (model, k) => {
        return (_openBlock(), _createBlock(_component_md_card, {
          key: k,
          variant: "filled",
          class: "model"
        }, {
          default: _withCtx(() => [
            (model.state == 'ongoing' || model.state == 'reviewing' || model.state == 'publishing')
              ? (_openBlock(), _createBlock(_component_md_progress_indicator_circular, {
                  key: 0,
                  class: "state",
                  size: "small"
                }))
              : (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: _normalizeClass(["material-icons-round state", [ _ctx.getModelData(model).mode ]])
                }, _toDisplayString(_ctx.getModelData(model).icon), 3)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.getLanguageName(model.language)), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.getModelData(model).title), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_md_button, {
                variant: "filled",
                disabled: model.state != 'untrained' && model.state != 'failed',
                onClick: ($event: any) => (_ctx.startTraining(model))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
}